import { render, staticRenderFns } from "./SingleUnitSelectedText.vue?vue&type=template&id=2f47a485&scoped=true&"
import script from "./SingleUnitSelectedText.vue?vue&type=script&lang=js&"
export * from "./SingleUnitSelectedText.vue?vue&type=script&lang=js&"
import style0 from "./SingleUnitSelectedText.vue?vue&type=style&index=0&id=2f47a485&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47a485",
  null
  
)

export default component.exports